import { httpClient } from '../api/http.client';

export interface MarkupSettings {
  warehousePercent: number;
  warehouseFixed: number;
  warehouseDeliveryDays: number;
  abroadPercent: number;
  abroadFixed: number;
  abroadDeliveryDays: number;
  abroadPricePriority: string;
  syncIntervalMinutes: number;
  autoCreateProducts: boolean;
  defaultCategoryId: number | null;
  updatedAt: string;
}

export interface SyncLog {
  id: number;
  startedAt: string;
  finishedAt: string | null;
  status: string;
  productsCreated: number;
  productsUpdated: number;
  sizesUpdated: number;
  errorsCount: number;
  errorMessage: string;
}

export interface SyncProgress {
  phase: string;
  totalProducts: number;
  processedProducts: number;
  currentArticle: string;
  productsCreated: number;
  productsUpdated: number;
  sizesUpdated: number;
  errorsCount: number;
  errCatalogFetch: number;
  errProductCreate: number;
  errSizeUpsert: number;
  errEngineFetch: number;
  errInfoLoader: number;
}

export interface SyncStatus {
  isRunning: boolean;
  lastSync: SyncLog | null;
  progress?: SyncProgress;
}

export class SyncRepository {
  async getSettings(): Promise<MarkupSettings> {
    return httpClient.get<MarkupSettings>('/api/admin/sync/settings');
  }

  async updateSettings(settings: Partial<MarkupSettings>): Promise<{ message: string }> {
    return httpClient.put<{ message: string }>('/api/admin/sync/settings', settings);
  }

  async triggerSync(): Promise<{ message: string }> {
    return httpClient.post<{ message: string }>('/api/admin/sync/trigger');
  }

  async getStatus(): Promise<SyncStatus> {
    return httpClient.get<SyncStatus>('/api/admin/sync/status');
  }

  async getLogs(): Promise<{ logs: SyncLog[] }> {
    return httpClient.get<{ logs: SyncLog[] }>('/api/admin/sync/log');
  }

  async cancelSync(): Promise<{ message: string }> {
    return httpClient.post<{ message: string }>('/api/admin/sync/cancel');
  }

  async refreshProducts(skus?: string[]): Promise<{ message: string }> {
    return httpClient.post<{ message: string }>('/api/admin/sync/refresh-products', skus ? { skus } : {});
  }
}

export const syncRepository = new SyncRepository();
